var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { NavText } from '../../NavBar/NavText';
import { trackCat } from '../../NavBar/constants';
import { useS4AMastheadContext } from '../../S4AMastheadProvider';
import styled from 'styled-components';
import { cssSpacing } from '@spotify-internal/encore-web/core';
export var maxLinks = 10;
var maxCharCount = 20;
var List = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: ", ";\n  gap: ", ";\n"], ["\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: ", ";\n  gap: ", ";\n"])), function (props) { return (props.inline ? 'row' : 'column'); }, function (props) { return (props.inline ? cssSpacing('base') : cssSpacing('looser-2')); });
export var LinkList = function (_a) {
    var links = _a.links, _b = _a.inline, inline = _b === void 0 ? false : _b, className = _a.className;
    var InteractiveElement = useS4AMastheadContext().InteractiveElement;
    return (React.createElement(List, { inline: inline, className: className }, links.slice(0, maxLinks).map(function (link, index) { return (React.createElement("li", { key: index, className: "link-list-item" },
        React.createElement(InteractiveElement, { customComponent: NavText, isFocus: link.isActive, href: link.href, size: "xsmall", openInNewTab: link.openInNewTab, trackingCategory: trackCat, trackingLabel: link.trackingLabel, label: link.label.length > maxCharCount
                ? link.label.slice(0, maxCharCount)
                : link.label }))); })));
};
var templateObject_1;
